import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectDealTypeFilter } from 'shared/selectors/filters/dealType';
import { IChipsOption } from '@cian/ui-kit';
import { DealTypeSelector } from 'shared/components/DealTypeSelector/DealTypeSelector';
import { FDealType } from '../../../../../../../packages/JsonQuery';

export const DealTypeContainer: FC = () => {
  const { value } = useSelector(selectDealTypeFilter);

  const onChange = useFilterChangeCallback();

  const handleObjectTypeChange = useCallback(
    (nextValue: FDealType) => {
      onChange({ action: 'setDealType', arguments: [nextValue] });
    },
    [onChange],
  );

  const options: IChipsOption<FDealType>[] = [
    { label: 'Купить', value: FDealType.Sale },
    { label: 'Снять', value: FDealType.RentLongterm },
    { label: 'Посуточно', value: FDealType.RentDaily },
  ];

  return (
    <AdvancedFilterRow label="Тип сделки">
      <DealTypeSelector value={[value]} options={options} onChange={handleObjectTypeChange} />
    </AdvancedFilterRow>
  );
};
